import { render, staticRenderFns } from "./address-form.vue?vue&type=template&id=809004c6&scoped=true&"
import script from "./address-form.vue?vue&type=script&lang=js&"
export * from "./address-form.vue?vue&type=script&lang=js&"
import style0 from "./address-form.vue?vue&type=style&index=0&id=809004c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809004c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('809004c6')) {
      api.createRecord('809004c6', component.options)
    } else {
      api.reload('809004c6', component.options)
    }
    module.hot.accept("./address-form.vue?vue&type=template&id=809004c6&scoped=true&", function () {
      api.rerender('809004c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/approval/@fragment/address-form.vue"
export default component.exports